import {
  Bot,
  Clapperboard,
  Code2,
  Globe,
  Inbox,
  LayoutDashboard,
  type LucideIcon,
  Megaphone,
  Package,
  Settings2,
  Users,
  Wallet,
} from 'lucide-react';

export interface Section {
  to: string;
  label: string;
  icon: LucideIcon;
  /** Не пункт меню, а вкладка раздела under (в меню подсвечивается он); в поиске Ctrl+K — есть. */
  under?: string;
}

export const SECTIONS: Section[] = [
  { to: '/', label: 'Сводка', icon: LayoutDashboard },
  { to: '/decisions', label: 'Решения', icon: Inbox },
  { to: '/agent', label: 'Агент', icon: Bot },
  {
    to: '/ads',
    label: 'Реклама',
    icon: Megaphone,
  },
  {
    to: '/offers',
    label: 'Офферы',
    icon: Package,
  },
  // В меню не больше 9 разделов (DESIGN §4): лендинги — вкладка «Офферов»
  { to: '/landings', label: 'Лендинги', icon: Globe, under: '/offers' },
  {
    to: '/creatives',
    label: 'Креативы',
    icon: Clapperboard,
  },
  {
    to: '/leads',
    label: 'Лиды',
    icon: Users,
  },
  {
    to: '/finance',
    label: 'Финансы',
    icon: Wallet,
  },
  { to: '/settings', label: 'Настройки', icon: Settings2 },
  // Режим разработчика: из «Настроек» и поиска Ctrl+K
  { to: '/dev', label: 'Разработка', icon: Code2, under: '/settings' },
];

/** Пункты бокового меню и «Ещё»: без вкладок-разделов. */
export const MENU = SECTIONS.filter((s) => !s.under);
